"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useFormValues = require("./useFormValues");
Object.keys(_useFormValues).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useFormValues[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useFormValues[key];
    }
  });
});
var _useOrderPrice = require("./useOrderPrice");
Object.keys(_useOrderPrice).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useOrderPrice[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useOrderPrice[key];
    }
  });
});